/**
 *云文档模块路由
 */
import { PAGE_LEVEL } from '@/constants';
import { isElectron } from '@/utils/electron';

export default {
  meta: { localeModules: ['cloudDocument', 'aiChat', 'aiChatConstants', 'report', 'roadshow', 'schedule', 'summary'] },
  path: '/document/cloudIndex',
  redirect: '/document/cloudIndex',
  children: [
    {
      path: '/document/note',
      name: 'myNote',
      component: () => import(/* webpackChunkName: 'document-note' */ '@/pages/cloudDocument/mySpace/myNotes/main.vue'),
      meta: {
        name: 'routers.cloud_document_my_notes',
        pageLevel: PAGE_LEVEL.FIRST,
        showThreeMenu: true,
        componentName: 'DocumentMySpaceNote',
        requireAuth: false,
        keepAlive: true
      }
    },
    {
      path: '/document/noteDetail',
      name: 'noteDetail',
      component: () =>
        import(/* webpackChunkName: 'document-note-detail' */ '@/pages/cloudDocument/mySpace/myNotes/nodesDetail.vue'),
      meta: {
        name: 'routers.cloud_document_note_detail',
        pageLevel: PAGE_LEVEL.SECOND,
        componentName: 'DocumentMySpaceNoteDetail',
        pageWidth: '960px',
        hiddenNav: true,
        single: true,
        hideOuterBreadcrumb: isElectron,
        electronSingle: true,
        requireAuth: false
      }
    },
    {
      path: '/document/mySpace/aiNote',
      name: 'aiNote',
      component: () =>
        import(/* webpackChunkName: 'document-note-ainote' */ '@/pages/cloudDocument/mySpace/aiNote/main.vue'),
      meta: {
        name: 'routers.cloud_document_ai_notes',
        pageLevel: PAGE_LEVEL.FIRST,
        showThreeMenu: true,
        componentName: 'DocumentMySpaceAINote',
        keepAlive: true,
        requireAuth: false
      }
    },
    {
      path: '/document/aiNoteDetail',
      name: 'aiNoteDetail',
      component: () =>
        import(/* webpackChunkName: 'document-note-detail' */ '@/pages/cloudDocument/mySpace/aiNote/aiNodesDetail.vue'),
      meta: {
        name: 'routers.cloud_document_note_detail',
        pageLevel: PAGE_LEVEL.SECOND,
        componentName: 'DocumentMySpaceAiNoteDetail',
        pageWidth: '960px',
        hiddenNav: true,
        single: true,
        hideOuterBreadcrumb: isElectron,
        electronSingle: true,
        requireAuth: false
      }
    },
    {
      path: '/document/compare',
      name: 'aiNoteCompare',
      component: () =>
        import(/* webpackChunkName: 'document-compare' */ '@/pages/scheduleManage/mine/roadshowMeetingPage.vue'),
      meta: {
        name: 'routers.cloud_document_ai_summary',
        requireAuth: false,
        // pageLevel: PAGE_LEVEL.SECOND,
        hideSecondMenu: true,
        single: true,
        // electron 下 打开新tab
        electronSingle: true,
        hideOuterBreadcrumb: isElectron
      }
    },
    {
      path: '/document/meetingNoteCompare',
      name: 'meetingNoteCompare',
      component: () => import(/* webpackChunkName: 'document-meetingnote-compare' */ '@/pages/voice/summaryDetail.vue'),
      meta: {
        name: 'routers.cloud_document_ai_summary',
        requireAuth: false,
        pageLevel: PAGE_LEVEL.SECOND,
        hideSecondMenu: true,
        single: true,
        // electron 下 打开新tab
        electronSingle: true,
        hideOuterBreadcrumb: true
      }
    },
    {
      path: '/document/recentlyList',
      name: 'recentlyList',
      component: () =>
        import(/* webpackChunkName: 'document-note-recentlylist' */ '@/pages/cloudDocument/mySpace/recentlyList.vue'),
      meta: {
        name: 'routers.cloud_document_recent_list',
        pageLevel: PAGE_LEVEL.FIRST,
        showThreeMenu: true,
        componentName: 'DocumentRecentlyList',
        keepAlive: true,
        parentPath: '/document/mySpace',
        //TODO 后端加上权限路径后移除
        requireAuth: false
      }
    },
    {
      // 云文档首页
      path: '/document/cloudIndex',
      name: 'cloudIndex',
      component: () => import(/* webpackChunkName: 'cloud-index' */ '@/pages/cloudDocument/mySpace/index.vue'),
      meta: {
        name: 'routers.cloud_document_cloud_document',
        requireAuth: false,
        // pageLevel: PAGE_LEVEL.SECOND,
        single: true,
        // electron 下 打开新tab
        electronSingle: true,
        hideOuterBreadcrumb: isElectron
      }
    },
    {
      path: '/document/cloudIndexTab',
      name: 'cloudIndexTab',
      component: () =>
        import(/* webpackChunkName: 'cloud-index-tab' */ '@/pages/cloudDocument/mySpace/cloudIndexTab.vue'),
      meta: {
        name: 'routers.cloud_document_cloud_document',
        pageLevel: PAGE_LEVEL.FIRST,
        componentName: 'CloudIndexTab',
        keepAlive: true,
        requireAuth: false
      }
    },
    {
      path: '/document/cloudPreview',
      name: 'cloudPreview',
      component: () => import(/* webpackChunkName: 'cloud-preview' */ '@/pages/cloudDocument/mySpace/preview.vue'),
      meta: {
        name: 'routers.cloud_document_cloud_document_preview',
        pageLevel: PAGE_LEVEL.FIRST,
        componentName: 'index',
        keepAlive: false,
        requireAuth: false,
        electronSingle: true
      }
    },
    {
      path: '/document/cloudDetail',
      name: 'cloudDetail',
      component: () => import(/* webpackChunkName: 'cloud-detail' */ '@/pages/cloudDocument/mySpace/details.vue'),
      meta: {
        name: 'routers.cloud_document_cloud_document_detail',
        requireAuth: false,
        // pageLevel: PAGE_LEVEL.SECOND,
        hideSecondMenu: true,
        single: true,
        // electron 下 打开新tab
        electronSingle: true,
        hideOuterBreadcrumb: isElectron,
        otherParent: ['/summary/list']
      }
    }
  ]
};
